import Head from 'next/head'
import { useRouter } from 'next/router'

const HelmetContainer = () => {
  const router = useRouter()

  if (router.pathname.includes('blog') || router.pathname === '/') return null

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="www.decormatters.com" />
        <meta name="twitter:image" content="https://s3.amazonaws.com/decormatters-dev-web/assets/seo/seo-logo@3x.png" />
        <meta property="og:url" content="https://www.decormatters.com" />
        <meta property="og:site_name" content="DecorMatters" />
        <meta property="og:image" content="https://s3.amazonaws.com/decormatters-dev-web/assets/seo/seo-logo@3x.png" />
        <meta name="google-site-verification" content="tc8tm4ArNtKEDRKnlRcx3Yci9kajD8h5x1vtRdrbOM0" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: 'DecorMatters',
              url: 'https://decormatters.com',
              logo: 'https://decormatters.com/logo192.png',
              sameAs: ['https://www.facebook.com/decormattersapp', 'https://www.instagram.com/decormattersapp']
            })
          }}
        ></script>
      </Head>
    </>
  )
}

export default HelmetContainer
